import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, RouterStateSnapshot } from '@angular/router';
import { PageMetaService } from '@shared/shared-meta/page-meta.service';
import { Injectable } from '@angular/core';

@Injectable()
export class CustomMetaGuard implements CanActivate, CanActivateChild {
  constructor(private readonly _pageMetaService: PageMetaService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const url = state.url;

    if (this._pageMetaService.isBrowserRenderingAfterSSR()) {
      return true;
    }

    const metaSettings = route.hasOwnProperty('data') ? route.data.meta : undefined;
    this._pageMetaService.applyRouteMeta(metaSettings);

    return true;
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.canActivate(route, state);
  }
}
